import { type HttpFeatureFlagsResponse } from '@/features/shared/services/FeatureFlags/types'
import { getObjectKeys } from '@/features/shared/utils/types'

export const cleanFlags = <TKey extends string>({
  data,
  defaultsFlags,
}: {
  data: HttpFeatureFlagsResponse | undefined
  defaultsFlags: Record<TKey, boolean>
}): Record<TKey, boolean> => {
  const flags = { ...defaultsFlags }

  if (!Array.isArray(data?.FeatureFlags) || !data.FeatureFlags.length) {
    return flags
  }

  const serverFlags = new Map(data.FeatureFlags.map((flag) => [flag.Name, flag.Value]))

  getObjectKeys(flags).forEach((key) => {
    const value = serverFlags.get(key)

    if (value !== undefined) {
      flags[key] = value
    }
  })

  return flags
}
